export type FilterValue = {
  categories: string[]
  targets: string[]
  regions: string[]
}

export const EMPTY_FILTER: FilterValue = { categories: [], targets: [], regions: [] }

export function filterCount(v: FilterValue): number {
  return v.categories.length + v.targets.length + v.regions.length
}
